/**
 * CustomerReceiptOptionScreen — Receipt delivery choice
 */
import React, { useState } from 'react';

const RECEIPT_OPTIONS = [
  { key: 'print', label: 'Print Receipt', icon: 'printer' },
  { key: 'sms', label: 'Text Receipt', icon: 'message' },
  { key: 'email', label: 'Email Receipt', icon: 'mail' },
  { key: 'none', label: 'No Receipt', icon: 'x' },
];

const ICONS = {
  printer: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-receipt-svg">
      <polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/>
      <rect x="6" y="14" width="12" height="8"/>
    </svg>
  ),
  message: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-receipt-svg">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-receipt-svg">
      <rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="22,7 12,13 2,7"/>
    </svg>
  ),
  x: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="cfd-receipt-svg">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  ),
};

export default function CustomerReceiptOptionScreen({ onSelect }) {
  const [showInput, setShowInput] = useState(null); // 'sms' | 'email'
  const [inputVal, setInputVal] = useState('');

  const handleSelect = (key) => {
    if (key === 'sms') {
      setShowInput('sms');
      setInputVal('');
    } else if (key === 'email') {
      setShowInput('email');
      setInputVal('');
    } else {
      onSelect(key);
    }
  };

  const submitInput = () => {
    if (inputVal.trim()) {
      onSelect(showInput, showInput === 'sms' ? inputVal : undefined, showInput === 'email' ? inputVal : undefined);
    }
  };

  if (showInput) {
    return (
      <div className="cfd-panel cfd-center cfd-slide-up" data-testid="receipt-input-screen">
        <h2 className="cfd-heading">{showInput === 'sms' ? 'Enter Phone Number' : 'Enter Email'}</h2>
        <input
          type={showInput === 'sms' ? 'tel' : 'email'}
          placeholder={showInput === 'sms' ? '(555) 123-4567' : 'email@example.com'}
          value={inputVal}
          onChange={(e) => setInputVal(e.target.value)}
          className="cfd-input cfd-input-large"
          autoFocus
          data-testid="receipt-contact-input"
        />
        <div className="cfd-btn-row">
          <button onClick={() => setShowInput(null)} className="cfd-btn-secondary" data-testid="receipt-cancel-btn">Cancel</button>
          <button onClick={submitInput} className="cfd-btn-primary" disabled={!inputVal.trim()} data-testid="receipt-send-btn">Send</button>
        </div>
      </div>
    );
  }

  return (
    <div className="cfd-panel cfd-center cfd-slide-up" data-testid="receipt-screen">
      <h2 className="cfd-heading">Receipt</h2>
      <p className="cfd-subtext">How would you like your receipt?</p>
      <div className="cfd-receipt-grid">
        {RECEIPT_OPTIONS.map(({ key, label, icon }) => (
          <button
            key={key}
            onClick={() => handleSelect(key)}
            className="cfd-receipt-btn"
            data-testid={`receipt-${key}-btn`}
          >
            <div className="cfd-receipt-icon">{ICONS[icon]}</div>
            <span>{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
